// extracted by mini-css-extract-plugin
export default {"videoCarouselContainer":"VideoCarousel_videoCarouselContainer__01NCP","videoCarouselItem":"VideoCarousel_videoCarouselItem__WW9D0"};